import axios, { AxiosError, AxiosResponse } from 'axios';
import { Adjuntos } from '../../../models/Adjuntos';
//import User from '../../../models/User';
import { interceptor } from '../../../utils/axios.interceptor';
import { adjuntosEndPoint, adjuntosFullSizeEndPoint, adjuntosThumbEndPoint } from '../../../utils/endPoints';

export const adjuntosInstance = axios.create();
interceptor(adjuntosInstance);
export class AdjuntosService {

  /**
   * Used to get the adjuntos list
   * @returns adjuntos list
   */
  async getAdjuntos(): Promise<{
    status: boolean;
    data: AxiosResponse | Adjuntos;
  }> {
    try {
      const response = await adjuntosInstance.get(adjuntosEndPoint);
      return {
        status: true,
        data: response.data.results,
      };
    } catch (error) {
      const err = error as AxiosError;
      return {
        status: false,
        data: err.response?.data as AxiosResponse,
      };
    }
  }

   /**
   * Used to get a image in full size
   * @returns one image full size
   */
    async getAdjuntoFullSize(id: number): Promise<{
       status: boolean;
       data: AxiosResponse | unknown;
     }> {
       try {
         const response = await adjuntosInstance.get(`${adjuntosFullSizeEndPoint}/${id}`, {responseType: 'arraybuffer'});
         //Convertir arrayBuffer a urlImage
         let blob = new Blob( [ response.data ], { type: "image/jpeg" } );
         let urlCreator = window.URL || window.webkitURL;
         let imageUrl = urlCreator.createObjectURL( blob );
         return {
           status: true,
           data: imageUrl,
         };
       } catch (error) {
         const err = error as AxiosError;
         return {
           status: false,
           data: err.response?.data,
         };
       }
     }

   /**
   * Used to get a image how thumbnail
   * @returns one image in size thumbnail
   */
    async getAdjuntoThumbnail(id: number): Promise<{
       status: boolean;
       data: AxiosResponse | unknown;
     }> {
       try {
         const response = await adjuntosInstance.get(`${adjuntosThumbEndPoint}/${id}`, {responseType: 'arraybuffer'});
         //Convertir arrayBuffer a urlImage
         let blob = new Blob( [ response.data ], { type: "image/jpeg" } );
         let urlCreator = window.URL || window.webkitURL;
         let imageUrl = urlCreator.createObjectURL( blob );
         return {
           status: true,
           data: imageUrl,
         };
       } catch (error) {
         const err = error as AxiosError;
         return {
           status: false,
           data: err.response?.data,
         };
       }
     }
}